import ResourceList from '../../resource/list';

const AssetsList = () => {

      return(
        <div>
          <ResourceList resource="assets" name="Assets"/>
        </div>
      )

}

export default AssetsList;